<script>
   import Layout from '../../layouts/main'
   import PageHeader from '@/components/page-header'
   import appConfig from "@/app.config";
    
   export default {
      page: {
         title: "Clinic Doctors",
         meta: [
            {
               name: "description",
               content: appConfig.description,
            },
         ],
      },
      components: { Layout, PageHeader },
      data() {
         return {
            title: "Clinic Doctors",
            items: [
               {
                  text: "Clinic",
                  href: "/clinics",
               },  
               {
                  text: "Clinic Doctors",
                  active: true,
               },                   
            ],

            doctors: [],
         };
      },
      mounted() {
    
      },

      methods: {
         
      }
   }
</script>
    
<template>
   <Layout>
      <PageHeader :title="title" :items="items" />
      <div class="row">
         <div class="col-12">
            <div class="card">
               <div class="card-body">
                  <!-- <h4 class="card-title"></h4>
                  <p class="card-title-desc"></p> -->

                  <!----- top button area starts---->
                  <div class="row mb-4">

                     <div class="col-md-7">
                        <h4>Aster Clinic</h4>
                        <h5>Kochi</h5>
                     </div>

                     <div class="col-md-5">
                        <router-link :to="{ name: 'patients' }" class="btn btn-primary float-end"><i class='bx bx-chevrons-left'></i> Back</router-link>
                     </div>
                  </div>
                  <!----- top button area ends---->

                  <!----- Listing length and search starts ----->
                  <div class="row mb-3">

                     

                     <div class="col-sm-12 col-md-6">
                        <div class="listing-length" >
                           <label
                              >Show
                              <select class="form-control" v-model="listing_length">
                                 <option value="5">5</option>
                                 <option value="10">10</option>
                                 <option value="15">15</option>
                              </select>
                              entries
                           </label>
                        </div>                        
                     </div>
                     <div class="col-sm-12 col-md-6">
                        <div class="listing-filter">
                           <label>
                              <input type="text" class="form-control" placeholder="Search" v-model="keyword"/>
                           </label>
                        </div>                     
                        
                     </div>
                  </div>
                  <!----- Listing length and search ends ----->

                  <!---- listing table starts -------->
                  <div class="table-responsive">
                     <table class="table table-bordered mb-0">
                        <thead class="table-light">
                           <tr>
                              <th>Name</th>  
                              <th>Specializations</th>
                              <th>Contact</th>
                              <th>Options</th>
                           </tr>
                        </thead>
                        <tbody>
                           <tr>
                              <td>Dr. Prasad Varkey</td>
                              <td>Orthopedic</td>
                              <td>
                                 Mob: +91 5556667778<br>
                                 Email: prasad@gmail.com
                              </td>                             
                              <td>
                                 <router-link :to="{ name: 'doctor.details' }" class="btn btn-primary me-2 mb-2 btn-sm">Doctor Details</router-link>
                              </td>
                           </tr>
                 
                        </tbody>
                     </table>
                  </div>
                  <!---- listing table ends -------->

                  <!----pagination starts --->     
                  <caption class="float-start mt-4 d-block d-lg-inline">Showing 1 to 10 of 26 entries</caption>               
                  <ul class="pagination pagination-rounded mt-4 float-lg-end d-md-inline-flex">
                     <li class="page-item disabled">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-left"></i>
                        </a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">1</a>
                     </li>
                     <li class="page-item active">
                        <a href="#" class="page-link">2</a>
                     </li>
                     <li class="page-item">
                        <a href="#" class="page-link">3</a>
                     </li>
                     
                     <li class="page-item">
                        <a href="#" class="page-link">
                           <i class="mdi mdi-chevron-right"></i>
                        </a>
                     </li>
                  </ul>
                  <!----pagination ends --->


               </div>
            </div>
         </div>
      </div>
   </Layout>
</template>
